module.exports = __webpack_public_path__ + "img/house02.94407655.jpg";